import { Box, Button, Checkbox, FormControlLabel, IconButton, Menu, MenuItem, MenuProps, Typography, styled } from "@mui/material";
import React, { useContext, useState } from "react";
import SettingsIcon from "@mui/icons-material/Settings";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import DownloadIcon from "@mui/icons-material/Download";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import LinkIcon from "@mui/icons-material/Link";
import { Context } from "../App";
import { ROUTE } from "../Interface/interface";
import UrlDataModal from "./Modal/urlDataModal";
import { getAcceptAttribute } from "../Configuration/utils";

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    marginTop: "8px",
    minWidth: 180,
    boxShadow: "0px 0px 5px rgba(19, 27, 41, 0.5)",
    "& .MuiMenu-list": {
      padding: "0px",
    },
  },
}));
const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

const DataOption = ({ handleFileUpload, inputError }: any) => {
  const { urlType, showJsonDataType, setShowJsonDataType, showObjectSize, setShowObjectSize, beautifiedCode, sethtmlRunView, htmlRunView } = useContext(Context);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [copySuccess, setCopySuccess] = useState(false);
  const [urlModalOpen, setUrlModalOpen] = useState(false);

  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleJsonDataTypeToggle = () => {
    setShowJsonDataType(!showJsonDataType);
    handleClose();
  };
  const handleObjectSizeToggle = () => {
    setShowObjectSize(!showObjectSize);
    handleClose();
  };
  const handleCopyClick = () => {
    copyToClipboard(beautifiedCode);
    handleClose();
    setCopySuccess(true);
    setTimeout(() => {
      setCopySuccess(false);
    }, 2000);
  };

  const copyToClipboard = (text: string) => {
    const textarea = document.createElement("textarea");
    textarea.value = text;
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
  };

  const handleFileDownload = () => {
    const fileName = `data.${getAcceptAttribute(urlType)}`;
    const blob = new Blob([beautifiedCode], { type: "application/json" });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center" flexWrap="wrap">
      <Button
        component="label"
        variant="outlined"
        startIcon={<FileUploadIcon />}
        sx={{
          textTransform: "capitalize",
          minWidth: "40px",
          mx: 1,
        }}
      >
        <VisuallyHiddenInput type="file" onChange={handleFileUpload} accept={`.${getAcceptAttribute(urlType)}`} /> File
      </Button>
      {/* <Button variant="outlined" startIcon={<LinkIcon />}>
          URL
        </Button> */}
      {urlType === ROUTE.HTML_FORMATOR && (
        <Button
          component="label"
          variant="outlined"
          sx={{
            textTransform: "capitalize",
            minWidth: "40px",
            mx: 1,
          }}
          onClick={() => sethtmlRunView(!htmlRunView)}
          disabled={inputError || beautifiedCode.length === 0 ? true : false}
        >
          {htmlRunView ? "Beautify HTML" : "Run HTML"}
        </Button>
      )}
      {urlType === ROUTE.JSON_PARSER ? (
        <IconButton onClick={handleClick}>
          <SettingsIcon />
        </IconButton>
      ) : (
        <>
          <IconButton
            onClick={handleFileDownload}
            disabled={inputError || beautifiedCode.length === 0 ? true : false}
            sx={{
              textTransform: "capitalize",
              minWidth: "40px",
              mx: 1,
              "& .MuiButton-startIcon": {},
            }}
          >
            <DownloadIcon />
          </IconButton>
          <Box position="relative">
            <IconButton onClick={handleCopyClick} disabled={inputError || beautifiedCode.length === 0 ? true : false}>
              <ContentCopyIcon />
            </IconButton>
            <Typography className="copy-text" sx={{ color: "green" }}>
              {copySuccess ? "Copied!" : ""}
            </Typography>
          </Box>
        </>
      )}
      <StyledMenu
        id="teb-space-dropdown"
        MenuListProps={{
          "aria-labelledby": "teb-space-dropdown",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem>
          <FormControlLabel control={<Checkbox checked={showObjectSize} onClick={handleObjectSizeToggle} />} label="Object Size" defaultChecked />
        </MenuItem>
        <MenuItem>
          <FormControlLabel control={<Checkbox checked={showJsonDataType} onClick={handleJsonDataTypeToggle} />} label="Data Type" />
        </MenuItem>
      </StyledMenu>
      {/* <UrlDataModal urlModalOpen={urlModalOpen} setUrlModalOpen={setUrlModalOpen} /> */}
    </Box>
  );
};

export default DataOption;
